import VueRouter, { Route } from 'vue-router';

import { RouteName } from '../../../routes/routes.constants';
import { magic } from '@gig/magic-sdk';
import type { IGetAmlStatusResponse } from '@gig/magic-sdk/dist/adapter/users/getAmlStatus';
import { AML_STATUS_QUERY, GRACE_PERIOD_QUERY } from '@gig/magic-messages';
import type { IGracePeriod } from '@gig/magic-sdk/dist/adapter/users/getGracePeriod';
import {
    getGracePeriodDaysLeft,
    isKYCRequestedByAML,
} from '@gig/magic-jurisdictions';

export function isSOWHidden(route: Route) {
    return route.matched.some(({ meta }) => meta.allowWithPendingGracePeriod);
}

export function allowWithPendingGracePeriod(
    allowWithPendingGracePeriod: boolean = true,
) {
    return {
        allowWithPendingGracePeriod,
    };
}

export function initGracePeriodGuard(router: VueRouter) {
    router.beforeResolve(async (to, _, next) => {
        if (!magic.session.getUser() || !(await hasGracePeriodExpired())) {
            return next();
        }

        if (isSOWHidden(to) || to.name === RouteName.HOME) {
            return next();
        }

        if (isExpiredModalOpen()) {
            return next(
                new Error(
                    'Navigation canceled due to user block (grace period expired)',
                ),
            );
        }

        return next({
            name: RouteName.HOME,
        });
    });
}

async function hasGracePeriodExpired() {
    const [amlStatus, periods] = await Promise.all([
        window.queryBus.query<IGetAmlStatusResponse>(AML_STATUS_QUERY)!,
        window.queryBus.query<IGracePeriod[]>(GRACE_PERIOD_QUERY)!,
    ]);
    const daysLeft = getGracePeriodDaysLeft(periods);
    const status = amlStatus?.status;
    return !daysLeft && status && isKYCRequestedByAML(status);
}

function isExpiredModalOpen() {
    return (
        document.getElementsByTagName('magic-sow-countdown-prompt').length != 0
    );
}
